function o(...n) {
  if (n.length === 1) {
    const e = n[0];
    return console.log(e), e;
  } else {
    const e = n[1];
    return console.log(n[0], e), e;
  }
}
window.dbg = o;
//# sourceMappingURL=index.js.map
